// extracted by mini-css-extract-plugin
module.exports = {"message-avatars":"message-avatars__3vj_P","message-avatars__avatar":"message-avatars__avatar__2w8Pn"};